import AxiosInstance from '@src/Common/Services/Api/AxiosInstance';

/**
 *
 * @param idempotencyId is the PageName
 */
const AxiosInstanceGlobalEvent = (idempotencyId: string) =>
  AxiosInstance(idempotencyId, process.env.API_GLOBAL_EVENT_URL ?? '');
export default AxiosInstanceGlobalEvent;
